import { error, success } from '@react/react-spectrum/Toast/js/ToastContainer';

/**
 * @description Copies provided text to clipboard and shows a success toast preferably
 * @param {string} text
 * @param {boolean} [showSuccessToast=true]
 */
export const copyText = async (text, showSuccessToast = true) => {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.textContent = text;
      document.body.append(textArea);
      textArea.select();
      textArea.focus();
      document.execCommand('copy');
      textArea.remove();
    }
    if (showSuccessToast) {
      success('Copied to clipboard', { timeout: 3000 });
    }
  } catch (err) {
    console.error('Failed to copy text: ', err);
    if (showSuccessToast) {
      error('Failed to copy text', { timeout: 0 });
    }
  }
};
